module.exports = {
        srcSet: __webpack_public_path__ + "d036766a4932390d-350.webp"+" 350w",
        images: [{path: __webpack_public_path__ + "d036766a4932390d-350.webp",width: 350,height: 250}],
        src: __webpack_public_path__ + "d036766a4932390d-350.webp",
        toString: function(){return __webpack_public_path__ + "d036766a4932390d-350.webp"},
        
        width: 350,
        height: 250
      }